<div class="file-input-history-wrapper">
  <app-form-section-header [title]="titleKey | translate"></app-form-section-header>

  @if (uploadError) {
    <div class="alert alert-danger">
      {{ uploadError }}
    </div>
  }

  @if (removeError) {
    <div class="alert alert-danger">
      {{ removeError }}
    </div>
  }

  <div class="files-container" [class.has-overlay]="isUploading || hasRemovingItems()">
    @if (isUploading || hasRemovingItems()) {
      <div class="loading-overlay">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
        </div>
        @if (isUploading) {
          <p class="mt-2 mb-0">{{ 'FILE_INPUT_HISTORY.UPLOADING' | translate }}</p>
        }
        @if (!isUploading && hasRemovingItems()) {
          <p class="mt-2 mb-0">
            {{ 'FILE_INPUT_HISTORY.DELETING' | translate }}
          </p>
        }
      </div>
    }

    @for (attachment of filteredAttachments; track attachment) {
      <div class="file-item">
        <div class="file-info">
          <span class="file-label">{{ 'FILE_INPUT_HISTORY.FILE_NAME' | translate }}</span>
          <span class="file-name">{{ attachment.fileName || ('FILE_INPUT_HISTORY.NO_NAME' | translate) }}</span>
        </div>
        <div class="file-actions">
          @if (getAttachmentId(attachment)) {
            <button
              type="button"
              class="btn-action"
              [disabled]="isCurrentlyDownloading(getAttachmentId(attachment)!)"
              (click)="downloadDocument(getAttachmentId(attachment)!, attachment.fileName)"
              >
              @if (!isCurrentlyDownloading(getAttachmentId(attachment)!)) {
                <span>
                  {{ 'FILE_INPUT_HISTORY.DOWNLOAD' | translate }}
                </span>
              }
              @if (isCurrentlyDownloading(getAttachmentId(attachment)!)) {
                <span>
                  {{ 'FILE_INPUT_HISTORY.DOWNLOADING' | translate }}
                </span>
              }
            </button>
          }
          @if (getAttachmentId(attachment) && !disabled) {
            <button
              type="button"
              class="btn-action"
              [disabled]="isCurrentlyRemoving(getAttachmentId(attachment)!)"
              (click)="deleteDocument(getAttachmentId(attachment)!)"
              >
              {{ 'FILE_INPUT_HISTORY.DELETE' | translate }}
            </button>
          }
        </div>
      </div>
    }

    @if (!filteredAttachments || filteredAttachments.length === 0) {
      <div class="no-files-message">
        <p class="file-name mb-0">{{ noFilesKey | translate }}</p>
      </div>
    }
  </div>

  <div class="upload-section">
    <app-file-input
      [labelKey]="uploadLabelKey"
      [accept]="accept"
      [infoPopover]="infoPopover"
      [formControl]="fileControl"
      [disabled]="isUploading"
      [hideLabel]="hideUploadLabel"
      (fileSelected)="onFileSelected($event)"
      (fileRemoved)="onFileRemoved()"
      >
    </app-file-input>
  </div>
</div>
